
import { Menu } from '@headlessui/react';
import * as R from 'ramda';
import React, { useEffect, useState } from 'react';
import CommonModal from '../../models/common-modal';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { selectCurrent } from '../../redux/settings/selectors';
import { settings } from '../../redux/settings/actions';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { CancelReasonComponents } from './cancel-reasons.component';
import { FulfillmentOrderStatusComponents } from './fulfillment-order-status.component';
import { cancelReasons } from '../../redux/cancel-reasons/action';
import { selectCancelReasonsListItems } from '../../redux/cancel-reasons/selector';
import { agents } from '../../redux/agents/action';
import { AgentAssign } from './agent-assign/agent-assign';
import { selectAgentsListItems } from '../../redux/agents/selector';
import { colorMapping } from '../services/utils';
import { PaymentStatusActionMobileComponent } from './payment-status-action-mobile.component';
import CommonModalMobile from '../../models/common-modal-mobile';


export function MobileLibraryRendererComponent({ onAgentAssignClick, onCargoDriverStatusClick, onCargoDeliveryStatusClick, onCargoTransitStatusClick, onCargoIssueStatusClick, onCargoPickupStatusClick, onCargoOrderStatusClick, onFulfillmentOrderStatusSubmit, isFulifllmentOrderEditble, onOrderStatusClick, onPaymentStatusClick, onFullfillmentStatusSubmit, onShippingStatusClick, onReturnRequestStatusClick, value, cellRendererParams, data, dataId, cellRenderer }: any) {
    const [
        libraryElement,
        setLibraryElement
    ] = useState<any>([]);
    const [
        colorDecider,
        setColorDecider
    ] = useState<any>();
    const [isCancel, setIsCancel] = useState<boolean>(false)
    const [isAgent, setIsAgent] = useState<boolean>(false)
    const [isPayment, setIsPayment] = useState<boolean>(false)
    const [
        paymentValues,
        setPaymentValues
    ] = useState<any>();
    const [
        fulfillmentOrderStatus,
        setFulfillmentOrderStatus
    ] = useState<any>();
    const [
        anchorFullfillmentEl,
        setAnchorFullfillmentEl
    ] = React.useState(null);
    const [
        anchorReturnRequestEl,
        setAnchorReturnRequestEl
    ] = React.useState(null)
    const [
        anchorShipmentEl,
        setAnchorShipmentEl
    ] = React.useState(null);
    const [
        anchorCargoOrderEl,
        setAnchorCargoOrderEl
    ] = React.useState(null);
    const [
        anchorCargoIssueEl,
        setAnchorCargoIssueEl
    ] = React.useState(null);
    const [
        anchorCargoTransitEl,
        setAnchorCargoTransitEl
    ] = React.useState(null);
    const [
        anchorCargoDriverEl,
        setAnchorCargoDriverEl
    ] = React.useState(null);
    const [
        anchorCargoDeliveryEl,
        setAnchorCargoDeliveryEl
    ] = React.useState(null);
    const [
        anchorCargoPickupEl,
        setAnchorCargoPickupEl
    ] = React.useState(null);
    const [
        anchorOrderEl,
        setAnchorOrderEl
    ] = React.useState(null);
    const cancelitemsData = useSelector(selectCancelReasonsListItems)
    const transportAgentListItems = useSelector(selectAgentsListItems)
    const { getCommonModal } = useAppSelector(selectCurrent)
    const handleShipmentSubmit = (event: any) => {
        onShippingStatusClick(
            event,
            dataId
        )
        handleMenuClose()
    }

    const handleMenuClose = () => {
        setAnchorReturnRequestEl(null)
        setAnchorOrderEl(null)
        setAnchorShipmentEl(null)
        setAnchorFullfillmentEl(null)
    };
    const handleOrderSubmit = (event: any) => {
        onOrderStatusClick(
            event,
            dataId
        )
        handleMenuClose()
    }
    const handleShippingSubmit = (event: any) => {
        onShippingStatusClick(
            event,
            dataId
        )
        handleMenuClose()
    }
    const handleCargoOrderSubmit = (event: any) => {
        onCargoOrderStatusClick(
            event,
            dataId
        )
        handleMenuClose()
    }
    const handleCargoIssueSubmit = (event: any) => {
        onCargoIssueStatusClick(
            event,
            dataId
        )
        handleMenuClose()
    }
    const handleCargoTransitSubmit = (event: any) => {
        onCargoTransitStatusClick(
            event,
            dataId
        )
        handleMenuClose()
    }
    const handleCargoDriverSubmit = (event: any) => {
        onCargoDriverStatusClick(
            event,
            dataId
        )
        handleMenuClose()
    }
    const handleCargoDeliverySubmit = (event: any) => {
        onCargoDeliveryStatusClick(
            event,
            dataId
        )
        handleMenuClose()
    }
    const handleCargoPickupSubmit = (event: any) => {
        onCargoPickupStatusClick(
            event,
            dataId
        )
        handleMenuClose()
    }
    const handleFullfillmentSubmit = (event: any) => {
        onFullfillmentStatusSubmit(
            event,
            dataId
        )
        handleMenuClose()
    }

    const handleReturnRequestSubmit = (event: any) => {
        onReturnRequestStatusClick(
            event,
            dataId
        )
        handleMenuClose()
    }
    const [
        open,
        setOpen
    ] = React.useState(false);
    const dispatch = useAppDispatch()
    const [
        selectedValue,
        setSelectedValue
    ] = useState<any>();
    const [
        selectedAgentValue,
        setSelectedAgentValue
    ] = useState<any>();
    const paymentLibrary = [
        { Disabled: false, Selected: false, Text: 'Pending', Description: 'Pending', Value: 10 },
        { Disabled: false, Selected: false, Text: 'Paid', Description: 'Paid', Value: 30 },
        { Disabled: false, Selected: false, Text: 'PartiallyPaid', Description: 'PartiallyPaid', Value: 35 }
    ]

    const handleClose = () => {
        setOpen(false);

    };
    const handleFulifllmentOrderEditbleOpen = async () => {

        await dispatch(settings.set({ getCommonModal: 'open' }))

        await dispatch(cancelReasons.list({
            url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/dom/cancel-reasons/list`, entity: 'cancelReasons', jsonData: {

                Filters: [
                    {
                        FieldName: 'CanceledBy',
                        FilterOperatorId: 6,
                        FieldValue: 30,
                        FieldType: 'text'
                    }
                ]


            }
        }))

    }
    const handlePaymentEditbleOpen = async () => {
        await setIsPayment(true)
        await dispatch(settings.set({ getCommonModal: 'open' }))
    }

    const handleRejectOpen = async () => {
        await setIsCancel(true)
        await dispatch(settings.set({ getCommonModal: 'open' }))

        await dispatch(cancelReasons.list({
            url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/dom/cancel-reasons/list`, entity: 'cancelReasons', jsonData: {

                Filters: [
                    {
                        FieldName: 'CanceledBy',
                        FilterOperatorId: 6,
                        FieldValue: 30,
                        FieldType: 'text'
                    }
                ]


            }
        }))

    };

    const handleFulfillmentOrderSubmit = () => {
        const resonDesription: any = _.filter(
            cancelitemsData?.result?.items,
            { Code: fulfillmentOrderStatus?.Code }

        );
        fulfillmentOrderStatus.Description = resonDesription[0]?.Reason;
        onFulfillmentOrderStatusSubmit(
            fulfillmentOrderStatus,
            dataId
        )

        handleFulfillmentOrderStatusClose()
        setFulfillmentOrderStatus({})
    }

    useEffect(
        () => {
            if (cellRendererParams?.library) {
                const libraryData: any = R.find(
                    (requestType: any) => parseInt(
                        requestType.Value,
                        10
                    ) === parseInt(
                        value,
                        10
                    ),
                    cellRendererParams?.library
                )
                setLibraryElement(libraryData ? libraryData.Text : '')
            }

        },
        [
            libraryElement,
            value
        ]
    );

    const handleCargoAgentAssignedOpen = async () => {
        await setIsAgent(true)
        await dispatch(settings.set({ getCommonModal: 'open' }))
        await dispatch(agents.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/list`, entity: 'agents', jsonData: {
            }
        }));
    }

    const getRandomTextColor = () => {
        const red = Math.floor(Math.random() * 128);
        const green = Math.floor(Math.random() * 128);
        const blue = Math.floor(Math.random() * 128);
        const hexRed = red.toString(16).padStart(2, "0");
        const hexGreen = green.toString(16).padStart(2, "0");
        const hexBlue = blue.toString(16).padStart(2, "0");

        const hexCode = `#${hexRed}${hexGreen}${hexBlue}`;
        return hexCode;
    }
    const randomColor = getRandomTextColor();

    const onFormChange: any = ({ field, value }: any) => {
        setSelectedValue({ ...selectedValue, [field]: value })
        setSelectedAgentValue({ ...selectedAgentValue, [field]: value })
    }
    const handleCancelation = () => {
        return (
            <CancelReasonComponents
                cancelreason={cancelitemsData?.result?.items}
                onFormChange={onFormChange}
                selectedValue={selectedValue}
            />
        );
    };
    const handleAgentAssign = () => {
        return (
            <AgentAssign
                transportAgents={transportAgentListItems.result.items}
                onFormChange={onFormChange}
                selectedValue={selectedAgentValue}
                Shippinglocation={dataId}
                agentTrack={data}
            />
        );
    }
    const handlePayment = () => {
        return (
            <PaymentStatusActionMobileComponent
                value={value}
                onPaymentFormChange={onPaymentFormChange}
                dataId={dataId}
                paymentValues={paymentValues}
                paymentLibrary={paymentLibrary}
            />
        );
    };
    const handleCancelationClose = () => {
        setSelectedValue({})
        dispatch(settings.set({ getCommonModal: 'close' }))
    }
    const handleAgentClose = () => {
        setSelectedAgentValue({})
        dispatch(settings.set({ getCommonModal: 'close' }))
    }
    const handlePaymentClose = () => {
        setPaymentValues({})
        dispatch(settings.set({ getCommonModal: 'close' }))
    }
    const onPaymentFormChange: any = ({ field, fieldValue }: any) => {
        setPaymentValues({ ...paymentValues, [field]: fieldValue })
    }
    const onFulfillmentFormChange: any = ({ field, fieldValue }: any) => {
        setFulfillmentOrderStatus({ ...fulfillmentOrderStatus, [field]: fieldValue })
    }
    const handleFulfillmentOrderStatus = () => {
        return (
            <FulfillmentOrderStatusComponents
                cancelreason={cancelitemsData?.result?.items}
                onFulfillmentFormChange={onFulfillmentFormChange}
                dataId={dataId}
                fulfillmentOrderStatus={fulfillmentOrderStatus}
            />
        );
    };
    const handleFulfillmentOrderStatusClose = () => {
        setFulfillmentOrderStatus({})
        dispatch(settings.set({ getCommonModal: 'close' }))
    }
    const handleOrderCancelSubmit = () => {
        if (data?.isOrderEditable) {
            onOrderStatusClick(
                -10,
                dataId,
                selectedValue?.Code
            )
        } else if (data?.isVendorShipmentEditable) {
            onShippingStatusClick(
                -10,
                dataId,
                selectedValue?.Code
            )
        }

        handleCancelationClose()
        setSelectedValue({})

    }
    const handleAgentCancelSubmit = () => {
        onAgentAssignClick(
            20,
            dataId,
            selectedAgentValue?.AgentId
        )
    }
    const handlePaymentSubmit = () => {
        onPaymentStatusClick(
            paymentValues,
            dataId
        )

        handlePaymentClose()
        setPaymentValues({})
    }

    useEffect(
        () => {
            const color: any = colorMapping[libraryElement] || "bg-gray-200"
            setColorDecider(color);
        }, [data?.isRowColorDecider, libraryElement])

    return (
        <>
            <div>


                {!isPayment && !isCancel && data?.isFulifllmentOrderEditble && getCommonModal == 'open' && <CommonModal title='Update Fulfillment Order Status' renderForm={handleFulfillmentOrderStatus}
                    onSubmit={handleFulfillmentOrderSubmit}
                    handleClose={handleFulfillmentOrderStatusClose}
                />}
                {isCancel && !isPayment && getCommonModal == 'open' && <CommonModal title='Cancel Confirmation' renderForm={handleCancelation}
                    onSubmit={handleOrderCancelSubmit}
                    handleClose={handleCancelationClose}
                />}
                {isAgent && !isPayment && !isCancel && !data?.isPaymentEditble && !data?.isFulifllmentOrderEditble && getCommonModal == 'open' && <CommonModal title='Assigning the Agent' renderForm={handleAgentAssign}
                    onSubmit={handleAgentCancelSubmit}
                    handleClose={handleAgentClose}
                />}
                {isPayment && !isCancel && data?.isPaymentEditble && getCommonModal == 'open' && <CommonModalMobile title='Update Payment Status' renderForm={handlePayment}
                    onSubmit={handlePaymentSubmit}
                    handleClose={handlePaymentClose}
                />}


            </div>

            <div>
                {!data?.isCargoDriverEditable && !data?.isCargoDeliveryEditable && !data?.isCargoTransitEditable && !data?.isCargoIssuesEditable && !data?.isCargoPickupEditable && !data?.isCargoOrderEditable && !data?.isVendorShipmentEditable && !data?.isPaymentEditble && !data?.isFulifllmentOrderEditble && !data?.isShipmentEditable && !data?.isOrderEditable && !data?.isShippingEditable && !data?.isPaymentEditble && !data?.isReturnRequestEditble && !data?.isOrderFulfillment && <span
                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 ${data?.isRowColorDecider ? colorDecider : ""} text-white`}
                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>

                    {libraryElement || null}
                </span>}

                {data?.isCargoOrderEditable
                    ? <>
                        <Menu as="div" className="relative  text-left">
                            <div>
                                <Menu.Button onClick={(e: any) => setAnchorCargoOrderEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white bg-${randomColor}`}
                                    style={{ backgroundColor: randomColor }}>
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorCargoOrderEl && (
                                <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1">
                                    <div className="px-1 py-1 ">
                                        {/* <Menu.Item>
                      <button
                        onClick={() => {
                          handleCargoOrderSubmit(50);
                          handleMenuClose();
                        }}
                        className="p-2 hover:bg-gray-100 w-full">

                        NA
                      </button>
                    </Menu.Item> */}
                                        {/* <Menu.Item>
                      <button
                        onClick={() => {
                          handleCargoOrderSubmit(10);
                          handleMenuClose();
                        }}
                        className="p-2 hover:bg-gray-100 w-full">

                        Booking Requested
                      </button>
                    </Menu.Item> */}
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoAgentAssignedOpen();
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100  w-full">

                                                Booking Confirmed
                                            </button>
                                        </Menu.Item>
                                        {/* <Menu.Item>
                      <button
                        onClick={() => {
                          handleCargoOrderSubmit(30);
                          handleMenuClose();
                        }}
                        className="p-2 hover:bg-gray-100  w-full">

                        Driver Assigned
                      </button>
                    </Menu.Item> */}
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleMenuClose();
                                                    handleRejectOpen();
                                                }}
                                                className="p-2 hover:bg-gray-100 w-full">

                                                Booking Canceled
                                            </button>
                                        </Menu.Item>

                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>
                    </>
                    : null}

                {data?.isCargoPickupEditable
                    ? <>
                        <Menu as="div" className="relative  text-left">
                            <div>
                                <Menu.Button onClick={(e: any) => setAnchorCargoPickupEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white ${data?.isRowColorDecider ? colorDecider : ""}`}
                                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorCargoPickupEl && (
                                <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1">
                                    <div className="px-1 py-1 ">
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoPickupSubmit(40);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 text-sm w-full">

                                                NA
                                            </button>
                                        </Menu.Item>
                                        {/* <Menu.Item>
                      <button
                        onClick={() => {
                          handleCargoPickupSubmit(10);
                          handleMenuClose();
                        }}
                        className="p-2 hover:bg-gray-100  w-full">

                        On The Way
                      </button>
                    </Menu.Item> */}
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoPickupSubmit(20);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 text-sm w-full">

                                                Arrived At Pickup Location
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoPickupSubmit(30);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 text-sm w-full">

                                                Cargo Loaded
                                            </button>
                                        </Menu.Item>


                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>
                    </>
                    : null}
                {data?.isCargoIssuesEditable
                    ? <>
                        <Menu as="div" className="relative text-left">
                            <div>
                                <Menu.Button
                                    onClick={(e: any) => setAnchorCargoIssueEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white ${data?.isRowColorDecider ? colorDecider : ""}`}
                                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}
                                >
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorCargoIssueEl && (
                                <Menu.Items
                                    className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1 "
                                >
                                    <div className="px-1 py-1">
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoIssueSubmit(50);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 text-sm w-full"
                                            >
                                                NA
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoIssueSubmit(-10);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 text-sm w-full"
                                            >
                                                Cargo Loading Issue
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoIssueSubmit(-20);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 text-sm w-full"
                                            >
                                                Vehicle Breakdown
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoIssueSubmit(-30);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 text-sm w-full"
                                            >
                                                Delivery Failed
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoIssueSubmit(-40);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 text-sm w-full"
                                            >
                                                Cargo Damaged
                                            </button>
                                        </Menu.Item>
                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>

                    </>
                    : null}
                {data?.isCargoTransitEditable
                    ? <>
                        <Menu as="div" className="relative  text-left">
                            <div>
                                <Menu.Button onClick={(e: any) => setAnchorCargoTransitEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white ${data?.isRowColorDecider ? colorDecider : ""}`}
                                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorCargoTransitEl && (
                                <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1">
                                    <div className="px-1 py-1 ">
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoTransitSubmit(40);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 w-full">

                                                NA
                                            </button>
                                        </Menu.Item>
                                        {/* <Menu.Item>
                      <button
                        onClick={() => {
                          handleCargoTransitSubmit(10);
                          handleMenuClose();
                        }}
                        className="p-2 hover:bg-gray-100 w-full">

                        In Transit
                      </button>
                    </Menu.Item> */}
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoTransitSubmit(20);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100  w-full">

                                                Stopped For Inspection
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoTransitSubmit(30);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100  w-full">

                                                Delayed In Transit
                                            </button>
                                        </Menu.Item>

                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>
                    </>
                    : null}
                {data?.isCargoDeliveryEditable
                    ? <>
                        <Menu as="div" className="relative  text-left">
                            <div>
                                <Menu.Button onClick={(e: any) => setAnchorCargoDeliveryEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white ${data?.isRowColorDecider ? colorDecider : ""}`}
                                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorCargoDeliveryEl && (
                                <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1">
                                    <div className="px-1 py-1 ">
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoDeliverySubmit(40);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 w-full">

                                                NA
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoDeliverySubmit(10);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 w-full">

                                                Arrived At Delivery Location
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoDeliverySubmit(20);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100  w-full">

                                                Cargo Unloaded
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoDeliverySubmit(30);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100  w-full">

                                                Delivery Completed
                                            </button>
                                        </Menu.Item>

                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>
                    </>
                    : null}
                {data?.isCargoDriverEditable
                    ? <>
                        <Menu as="div" className="relative  text-left">
                            <div>
                                <Menu.Button onClick={(e: any) => setAnchorCargoDriverEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white ${data?.isRowColorDecider ? colorDecider : ""}`}
                                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorCargoDriverEl && (
                                <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1">
                                    <div className="px-1 py-1 ">

                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoDriverSubmit(10);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 w-full">

                                                Pending
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleCargoDriverSubmit(20);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100  w-full">

                                                Accepted
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleMenuClose();
                                                    handleRejectOpen();
                                                }}
                                                className="p-2 hover:bg-gray-100  w-full">

                                                Rejected
                                            </button>
                                        </Menu.Item>

                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>
                    </>
                    : null}
                {data?.isFulifllmentOrderEditble ? <><span
                    onClick={() => {
                        handleFulifllmentOrderEditbleOpen()

                    }}
                    className='p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white'
                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>

                    CancelledItem
                </span></>
                    : null}
                {data?.isPaymentEditble ? <><span
                    onClick={() => {
                        handlePaymentEditbleOpen()

                    }}
                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300  text-white ${data?.isRowColorDecider ? colorDecider : ""}`}
                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>

                    {libraryElement || null}
                </span></>
                    : null}
                {data?.isOrderEditable
                    ? <>
                        <Menu as="div" className="relative text-left ">
                            <div>
                                <Menu.Button onClick={(e: any) => setAnchorOrderEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white ${data?.isRowColorDecider ? colorDecider : ""} `}
                                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorOrderEl && (
                                <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1">
                                    <div className="px-1 py-1 ">
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleOrderSubmit(20);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Accept
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleRejectOpen()
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Reject
                                            </button>
                                        </Menu.Item>

                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>
                    </>
                    : null}
                {data?.isShippingEditable
                    ? <>
                        <Menu as="div" className="relative  text-left">
                            <div>
                                <Menu.Button onClick={(e: any) => setAnchorShipmentEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white ${data?.isRowColorDecider ? colorDecider : ""}`}
                                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorShipmentEl && (
                                <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1">
                                    <div className="px-1 py-1 ">
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleShippingSubmit(30);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Shipped
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleShippingSubmit(60);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Delivered
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleMenuClose();
                                                    handleRejectOpen();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Reject
                                            </button>
                                        </Menu.Item>
                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>
                    </>
                    : null}
                {data?.isOrderFulfillment
                    ? <>
                        <Menu as="div" className="text-left">
                            <div>
                                <Menu.Button onClick={(e: any) => setAnchorFullfillmentEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white ${data?.isRowColorDecider ? colorDecider : ""}`}
                                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorFullfillmentEl && (
                                <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1">
                                    <div className="px-1 py-1 ">
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleFullfillmentSubmit(20);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Packed
                                            </button>
                                        </Menu.Item>

                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>
                    </>
                    : null}

                {data?.isShipmentEditable || data?.isVendorShipmentEditable
                    ? <>
                        <Menu as="div" className="relative  text-left w-auto">
                            <div>
                                <Menu.Button onClick={(e: any) => setAnchorShipmentEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white ${data?.isRowColorDecider ? colorDecider : ""}`}
                                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorShipmentEl && (
                                <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1">
                                    <div className="px-1 py-1 ">
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleShipmentSubmit(30);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Order-picked-up
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleShipmentSubmit(50);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Out-for-delivery
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleShipmentSubmit(60);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Order-delivered
                                            </button>
                                        </Menu.Item>
                                        {data?.isVendorShipmentEditable &&
                                            <Menu.Item>
                                                <button
                                                    onClick={() => {
                                                        handleRejectOpen();
                                                        handleMenuClose();
                                                    }}
                                                    className="p-2 hover:bg-gray-100 ">

                                                    Cancel
                                                </button>
                                            </Menu.Item>}
                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>
                    </> : null}
                {data?.isReturnRequestEditble
                    ? <>
                        <Menu as="div" className="relative  text-left">
                            <div>
                                <Menu.Button onClick={(e: any) => setAnchorReturnRequestEl(e.currentTarget)}
                                    className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110  hover:bg-blue-300 duration-300 text-white ${data?.isRowColorDecider ? colorDecider : ""}`}
                                    style={!data?.isRowColorDecider ? { backgroundColor: randomColor } : {}}>
                                    {libraryElement || null}
                                </Menu.Button>
                            </div>
                            {anchorReturnRequestEl && (
                                <Menu.Items className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded shadow-lg p-1">
                                    <div className="px-1 py-1 ">
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleReturnRequestSubmit(20);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Accepted
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleReturnRequestSubmit(30);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                PickedUp
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleReturnRequestSubmit(40);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Rejected
                                            </button>
                                        </Menu.Item>
                                        <Menu.Item>
                                            <button
                                                onClick={() => {
                                                    handleReturnRequestSubmit(25);
                                                    handleMenuClose();
                                                }}
                                                className="p-2 hover:bg-gray-100 ">

                                                Liquidated
                                            </button>
                                        </Menu.Item>
                                    </div>
                                </Menu.Items>
                            )}
                        </Menu>
                    </> : null}
            </div>

        </>

    )
}
